import {
    Fundamental,
    StockProfile,
    News,
    Indicator,
} from './components';
import React, { useEffect } from 'react';
import { connect } from "react-redux";
import * as actions_stock from "redux/actions/stockActions";
import * as actions_news from "redux/actions/stockNewsActions";
import * as actions_quote from "redux/actions/quoteActions";
import MarketWinLow from 'components/MarketWinLow';
import MiniLoader from 'components/MiniLoader';
import 'assets/css/stock.css';

const Stock = (props) => {
    const ticker = props.match.params.ticker;

    useEffect(() => {
        if (!ticker || !props.user_id) {
            return;
        }
        const params = { id: props.user_id, symbol: ticker };
        props.loadItem(params, props.token);
        props.loadList(params, props.token);
        props.loadIndicator(params, props.token);
    }, [ticker, props.user_id]);

    useEffect(() => {
        if (!ticker || !props.user_id) {
            return undefined;
        }
        const symbol = ticker.trim().toUpperCase();
        const refreshQuote = () => {
            props.loadStockQuotes([symbol], props.user_id, props.token);
        };
        refreshQuote();
        const interval = setInterval(refreshQuote, 60000);
        return () => clearInterval(interval);
    }, [ticker, props.user_id, props.token, props.loadStockQuotes]);

    if (props.loading && !props.item?.symbol) {
        return (
            <div className="stock-page stock-loading">
                <MiniLoader />
            </div>
        );
    }

    return (
        <div className="stock-page">
            <div className="stock-main">
                <StockProfile />
                <Indicator />
                <Fundamental />
                <News />
            </div>
            <aside className="stock-side">
                <MarketWinLow />
            </aside>
        </div>
    );
};

function mapStateToProps(reducer) {
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,
        item: reducer.stock.item,
        loading: reducer.stock.loading,
    };
}

const mapDispatchToProps = dispatch => ({
    loadItem: (params, token) =>
        dispatch(actions_stock.loadItem({ params, token })),
    loadList: (params, token) =>
        dispatch(actions_news.loadList({ params, token })),
    loadIndicator: (params, token) =>
        dispatch(actions_news.loadIndicator({ params, token })),
    loadStockQuotes: (symbols, user_id, token) =>
        dispatch(actions_quote.loadStockQuotes({ symbols, user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Stock);
